import React, { useState, useRef } from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";


const GlobalFilter = ({
    showDateRange = false,
    showMake = false,
    showModel = false,
    showYear = false,
    showStatus,
    statusOptions = [],
    selectedStatus,
    onStatusChange,
    onSearch,
    onClear,
    selectedDates,
    makes = [],
    models = [],
    years = [],
    selectedMake,
    selectedModel,
    selectedYear,
    onMakeChange,
    onModelChange,
    onYearChange,
    onMakeInputChange,   // function to fetch makes
    onModelInputChange,  // function to fetch models
    onModelScrollToBottom,
    isModelLoading,
    isMakeLoading,
    isYearLoading
}) => {
    const makeRef = useRef(null);
    const [dateRange, setDateRange] = useState([]);

    // const getDefaultRange = () => {
    //     const today = new Date();
    //     return [
    //         new Date(today.getFullYear(), today.getMonth(), 1),
    //         new Date(today.getFullYear(), today.getMonth() + 1, 0),
    //     ];
    // };

    // useEffect(() => {
    //     if (!selectedDates || selectedDates.length === 0) {
    //         setDateRange(getDefaultRange());
    //     } else {
    //         setDateRange(selectedDates);
    //     }
    // }, [selectedDates]);


    const handleSearch = () => {

        const filters = {
            startDate: dateRange[0] || null,
            endDate: dateRange[1] || null,
            rawDates: dateRange,
            make: selectedMake || null,
            model: selectedModel || null,
            year: selectedYear || null,
            status: selectedStatus || null,
        };
        // console.log("Apply Filters clicked with:", filters);
        onSearch(filters);
    };

    //Clear filters
    const handleClear = () => {
        // Reset internal date range for this component only
        setDateRange([]);

        // Reset dropdowns if parent provided callbacks
        if (typeof onMakeChange === "function") onMakeChange(null);
        if (typeof onModelChange === "function") onModelChange(null);
        if (typeof onYearChange === "function") onYearChange(null);

        // Focus first dropdown if exists
        if (makeRef.current) makeRef.current.focus();

        // Notify parent to reset filters / fetch API
        if (typeof onClear === "function") onClear();
    };



    return (
        <div className="gf-wrapper">
            {showDateRange && (
                <div className="gf-field">
                    <label className="gf-label">Date Range</label>
                    <Flatpickr
                        options={{ mode: "range", dateFormat: "d/m/Y" }}
                        value={dateRange}
                        onChange={setDateRange}
                        className="gf-input"
                        placeholder="Start date - End date"
                    />
                </div>
            )}

            {showMake && (
                <div className="gf-field">
                    <label className="gf-label">Make</label>
                    <Select
                        classNamePrefix="react-select"
                        value={selectedMake}
                        options={makes}
                        placeholder="Select Make"
                        onFocus={() => {
                            // console.log("Make dropdown focused");
                            if (onMakeInputChange) onMakeInputChange(""); // fetch makes on focus
                        }}
                        onChange={(selected) => onMakeChange(selected || null)}
                        isLoading={isMakeLoading}
                        styles={{
                            container: (base) => ({
                                ...base,
                               

                            }),
                        }}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value.toString()}
                        isClearable
                    />
                </div>
            )}

            {showYear && (
                <div className="gf-field">
                    <label className="gf-label">Year</label>
                    <Select
                        classNamePrefix="react-select"
                        value={selectedYear}
                        options={years}
                        placeholder="Select Year"
                        onChange={(selected) => onYearChange(selected || null)}
                        isLoading={isYearLoading}
                        styles={{
                            container: (base) => ({
                                ...base,
                                
                            }),
                        }}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value.toString()}
                        isClearable
                    />
                </div>
            )}


            {showModel && (
                <div className="gf-field">
                    <label className="gf-label">Model</label>
                    <Select
                        classNamePrefix="react-select"
                        value={selectedModel}
                        options={models}
                        placeholder="Select Model"
                        // onFocus={() => {
                        //     console.log("tying model:",);

                        //     if (onModelInputChange && selectedMake)
                        //         onModelInputChange("");
                        // }}
                        onInputChange={(inputValue, { action }) => {
                            // action can be 'input-change', 'menu-close', etc.
                            if (action === 'input-change') {
                                console.log("inputValue ----------> ", inputValue);
                                if (onModelInputChange) onModelInputChange(inputValue);
                            }
                        }}
                        onChange={(selected) => {
                            console.log("Model selected:", selected);
                            onModelChange(selected || null);
                        }}
                        onMenuScrollToBottom={onModelScrollToBottom}
                        isLoading={isModelLoading}
                        styles={{ container: (base) => ({ ...base }) }}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value.toString()}
                        isClearable
                        isDisabled={!selectedMake} // optional: disable until Make is selected
                    // isDisabled={!(selectedMake?.value && selectedYear?.value)}
                    />
                </div>
            )}

            {showStatus && (
                <div className="gf-field status-field">
                    <label className="gf-label">Status</label>
                    <Select
                        classNamePrefix="react-select"
                        value={selectedStatus}
                        options={statusOptions.map(s => ({
                            label: s.title,
                            value: s.id,
                        }))}

                        styles={{
                            container: (base) => ({
                                ...base,
                              
                            }),
                        }}
                        placeholder="Select Status"
                        onChange={(selected) => onStatusChange(selected || null)}
                        isClearable
                    />
                </div>
            )}



            {/* Buttons */}
            <div className="gf-actions">
                <button className="gf-btn" onClick={handleSearch}>Apply Filters</button>
                <button className="gf-btn-clear" onClick={handleClear}>Clear</button>
            </div>
        </div>
    );
};

export default GlobalFilter;
